<template>

  <section class="" style="background: #F6F6F6;color:black">
    <div class="container ">
      <div class="section-title page-title">

        <div class="row m-0">
          <div class="col-12">
            <div class="content text-center">

              <ContentsCapitalLabel
                  isSecondaryColor="true"
                  label="QUALITY ISSUE, PROCESSING & TECHNICAL PROBLEMS"
              />
              <h2 class="title h2-caslon text-black text-center f-44 fw-600">Technical Troubleshooting</h2>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary section-technical-troubleshooting">
    <div class="container">
      <div class="page-content">

        <div class="content">
          <ContentsTextWithImage
              title="Technical Troubleshooting"
              image-url="/pages/products/services/tro.jpg"
              :contents="[
              'There’s a lot of room for expensive errors when it comes to injection molding. Quality issues in injection-molded products can range from minor surface defects to more serious problems that can affect the safety, performance and function of the product. They can be caused by problems related to the molding process, material use, tooling design or a combination of all three. We got your back all problems with technical expert both online or onsite',
            ]"
              is-reverse="true"
              is-white-content="true"
              left-width="50.267%"
              right-width="49.733%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page">
    <div class="container">
      <div class="page-content">
        <div class="content">

          <!-- CONTENT IMAGE RIGHT TEXT LEFT -->
          <div class="content-image-text custom-content-image-text">
            <div class="image text-center">
              <img src="/pages/products/services/trouble.jpg" alt="Technical troubleshooting illustration">
            </div>
            <div class="content ">
              <span class="title">Possible cause and most found issues</span>
              <!-- Paragraph tags -->
              <p>
                1. Stock temperature too low. <br />
                2. Mould temperature non-uniform or too low. <br />
                3. Mould fill too fast or too slow. <br />
                4. Excess mould lubricant. <br />
                5. Scratched or dirty mould surface. <br />
                6. Fill speed and/or packing time too low <br />
                7. Inadequate venting. <br />
                8. Improper gate location or design. <br />
                9. Flow Lines. <br />
                10. Sink Marks. <br />
                11. Vacuum Voids. <br />
                12. Surface Delamination. <br />
                13. Weld Lines. <br />
                14. Short Shots. <br />
                15. Warping. <br />
                16. Burn Marks.
              </p>
              <!-- Paragraph tags -->
            </div>
          </div>
          <!-- CONTENT IMAGE RIGHT TEXT LEFT -->

        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
useHead({
  title: 'Technical Troubleshooting - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.page-title {
  padding: 50px 0 0;
}

.page-title .title {
  margin: 40px 0 30px;
}

.custom-content-image-text {
  padding-top: 33px;
}

.custom-content-image-text .image,
.custom-content-image-text .content {
  width: 100%;
}

@media screen and (min-width: 768px) {
  .custom-content-image-text .image {
    width: 43.385%;
  }

  .custom-content-image-text .content {
    width: 56.615%;
  }
}

.custom-content-image-text .image img {
  width: auto;
}

.custom-content-image-text .content .title {
  font-family: 'Open Sans', sans-serif;
  font-size: 19px;
  font-weight: 600;

  color: #353535;

  display: block;
  margin-bottom: 25px;
}

.custom-content-image-text .content p {
  font-family: 'Myriad-Pro', sans-serif;
  font-weight: 400;
  font-size: 15px;

  line-height: 22.8px;
  /* letter-spacing: -0.2px; */

  color: #54595F;
}
</style>

<style>
.section-technical-troubleshooting .content-image-text .image {
  text-align: center;
}

.section-technical-troubleshooting .content-image-text .image img {
  width: auto;
}
</style>
